export default "__VITE_ASSET__19b7f133__"